module.exports = __webpack_public_path__ + "img/gzh.16266aa2.svg";